import { IonSegment, IonSegmentButton } from '@ionic/react';
import styled from 'styled-components';
import { AllieLikeDislikeButtonProps } from '../../LikeDislike.types';
import { IonSegmentProps } from '../../../../../common/components.types';
import { ComponentType } from 'react';

interface StyledContainerProps extends IonSegmentProps {
  size: number;
}

interface StyledLikeDislikeOutlineProps extends AllieLikeDislikeButtonProps {
  size: number;
}

export const StyledContainer: ComponentType<StyledContainerProps> = styled(IonSegment)<
  StyledContainerProps
>`
  height: ${(props) => props.size}px;
  width: ${(props) => (props.size * 8) / 3}px;
  column-gap: var(--allie-spacing-xl);
  --background: transparent;
`;

export const StyledLikeDislikeOutline: ComponentType<StyledLikeDislikeOutlineProps> = styled(
  IonSegmentButton
)<StyledLikeDislikeOutlineProps>`
  --padding-start: 0;
  --padding-end: 0;
  --padding-bottom: 0;
  --padding-top: 0;
  --indicator-color: ${(props: AllieLikeDislikeButtonProps) =>
    `var(--allie-color-${props.allieColor})`};
  --background-hover: var(--allie-color-neutral-10);
  --color-checked: transparent;
  --color-hover: transparent;
  --indicator-box-shadow: transparent;
  --border-style: none;
  min-width: ${(props) => props.size}px;
  min-height: auto;
`;
